import { AuthorizationRequest } from '../../types/AuthorizationRequest';

import {
  accountWebUrl,
  jobNurseSenkaUrl,
  medicalTermWebUrl,
  memberRegistrationUrl,
  myPageUrl,
  portalWebUrl,
  recruitWebUrl,
  surveyWebUrl,
} from './baseUrl';
import { generateAuthorizationUrl } from './generateAuthorizationUrl';

import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';

// Header内に存在するButtonに設定するURL一覧
export const headerButtonUrls = (
  appEnv: AppEnv,
  authorizationRequest: AuthorizationRequest,
) => ({
  memberRegistration: memberRegistrationUrl(appEnv),
  login: generateAuthorizationUrl(appEnv, authorizationRequest),
});

// Header内に存在するButtonに設定するURL一覧（ログイン済の場合はこっちを使う）
export const loggedInHeaderButtonUrls = (appEnv: AppEnv) => ({
  my: myPageUrl(appEnv),
});

// モーダルメニュー内のURL一覧
export const headerModalMenuUrls = (appEnv: AppEnv) => ({
  // 会員登録
  memberRegistration: memberRegistrationUrl(appEnv),
  // 看護用語集
  medicalTerm: medicalTermWebUrl(appEnv),
  // アンケート
  survey: surveyWebUrl(appEnv),
  // 転職サポート
  careerChangeSupport: `${portalWebUrl(appEnv)}/jobchange`,
  // 求人検索
  recruit: recruitWebUrl(appEnv),
  // ナース専科 求人ナビ
  jobNurseSenka: jobNurseSenkaUrl(appEnv),
});

// モーダルメニュー内のURL一覧（ログイン済の場合はこっちを使う）
export const loggedInHeaderModalMenuUrls = (appEnv: AppEnv) => ({
  // 看護用語集
  medicalTerm: headerModalMenuUrls(appEnv).medicalTerm,
  // アンケート
  survey: headerModalMenuUrls(appEnv).survey,
  // 転職サポート
  careerChangeSupport: headerModalMenuUrls(appEnv).careerChangeSupport,
  // 求人検索
  recruit: headerModalMenuUrls(appEnv).recruit,
  // ナース専科 求人ナビ
  jobNurseSenka: headerModalMenuUrls(appEnv).jobNurseSenka,
  // ログアウト
  logout: `${accountWebUrl(appEnv)}/logout`,
});
